/* ============================================================================
   Bold Grip Socks — Bundle Quick-Pick.
   Quick Add on a bundle card opens a mobile-friendly colour picker (choose N
   pairs across Aegean / Onyx / Artemis), then adds the bundle variant to cart
   with a properties[Colors] note. Single socks are untouched — bold-quick-add.js
   adds them straight to cart. Wired via window.BM_BUNDLE_QUICKPICK, which
   bold-quick-add.js checks before its own add.
   ES5 only — must run in the Instagram in-app browser and older mobile Safari.
   ========================================================================== */
(function () {
  var T = window.BM_I18N || {};
  function tt(s, tok, val){ return String(s).replace(tok, val); }
  'use strict';

  /* Colours come from window.BM_COLORWAYS via bm-cw.js, rebuilt each time the sheet opens
     (men's colours join on the men's pack sizes). */
  var CW = window.BMCW;
  var COLORS = [];
  var P = { row: 'bqp__row', dot: 'bqp__dot', name: 'bqp__name', stepper: 'bqp__stepper', step: 'bqp__step', count: 'bqp__count', attr: 'data-bqp' };
  function isSold(k) { var c = CW && CW.byKey(k); return !!(c && c.soldout); }

  var modal = null, els = {}, state = null, ctx = null;

  function build() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'bqp';
    modal.setAttribute('data-bqp', '');
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'bqp-title');

    modal.innerHTML =
      '<div class="bqp__backdrop" data-bqp-close></div>' +
      '<div class="bqp__sheet" role="document">' +
        '<button type="button" class="bqp__x" data-bqp-close aria-label="Close">×</button>' +
        '<div class="bqp__head">' +
          '<span class="bqp__eyebrow">Build your pack</span>' +
          '<h2 class="bqp__title" id="bqp-title" data-bqp-title>Bundle</h2>' +
          '<p class="bqp__sub">Pick <strong data-bqp-size>0</strong> pairs. Mix any colors.</p>' +
        '</div>' +
        '<div class="bqp__rows" data-bqp-rows></div>' +
        '<p class="bqp__hint" data-bqp-hint></p>' +
      '<p class="bm-backorder-note" data-bqp-bo hidden></p>' +
        '<button type="button" class="bqp__add" data-bqp-add disabled><span data-bqp-add-label>Add to cart</span></button>' +
      '</div>';

    document.body.appendChild(modal);
    els.title    = modal.querySelector('[data-bqp-title]');
    els.size     = modal.querySelector('[data-bqp-size]');
    els.hint     = modal.querySelector('[data-bqp-hint]');
    els.bo       = modal.querySelector('[data-bqp-bo]');
    els.add      = modal.querySelector('[data-bqp-add]');
    els.addLabel = modal.querySelector('[data-bqp-add-label]');

    modal.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-bqp-close]')) { close(); return; }
      var plus  = t.closest('[data-bqp-plus]');
      var minus = t.closest('[data-bqp-minus]');
      var add   = t.closest('[data-bqp-add]');
      if (plus)       { step(plus.getAttribute('data-bqp-plus'), 1); }
      else if (minus) { step(minus.getAttribute('data-bqp-minus'), -1); }
      else if (add)   { addToCart(); }
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && modal && !modal.hidden) close();
    });
  }

  function total() { return CW.total(state); }

  function colorsString() { return CW.colorsString(COLORS, state); }

  function step(key, delta) {
    if (!(key in state)) return;
    if (delta > 0 && isSold(key)) return;
    if (delta > 0 && total() >= ctx.size) { if (!CW.swapInto(COLORS, state, key)) return; render(); return; }
    if (delta < 0 && state[key] <= 0) return;
    state[key] += delta;
    render();
  }

  function render() {
    var n = total();
    for (var i = 0; i < COLORS.length; i++) {
      var key = COLORS[i].key;
      var sold = isSold(key);
      var cnt = modal.querySelector('[data-bqp-count="' + key + '"]');
      if (cnt) cnt.textContent = state[key];
      var row = modal.querySelector('[data-bqp-row="' + key + '"]');
      if (row) { row.classList.toggle('is-active', state[key] > 0 && !sold); row.classList.toggle('is-soldout', sold); }
      var minus = modal.querySelector('[data-bqp-minus="' + key + '"]');
      if (minus) minus.disabled = sold || state[key] === 0;
      var plus = modal.querySelector('[data-bqp-plus="' + key + '"]');
      if (plus) plus.disabled = sold || (n >= ctx.size && state[key] >= n);
    }
    if (n === ctx.size) {
      els.add.disabled = false;
      els.addLabel.textContent = ctx.price ? ((T.addToCart || 'Add to cart') + ' · ' + ctx.price) : (T.addToCart || 'Add to cart');
      els.hint.textContent = '✓ ' + n + '/' + ctx.size + ' pairs picked · ' + (T.swapHint || 'tap + to swap a colour');
      els.hint.className = 'bqp__hint is-ready';
    } else {
      els.add.disabled = true;
      var rem = ctx.size - n;
      els.addLabel.textContent = T.pickMore ? tt(T.pickMore, '[n]', rem) : ('Pick ' + rem + ' more');
      els.hint.textContent = T.pickMoreContinue ? tt(T.pickMoreContinue, '[n]', rem) : ('Pick ' + rem + ' more pair' + (rem === 1 ? '' : 's') + ' to continue');
      els.hint.className = 'bqp__hint';
    }
    if (els.bo) {
      var boKeys = CW.backorderKeys(COLORS, state);
      if (boKeys.length) { els.bo.textContent = CW.notice(boKeys); els.bo.hidden = false; }
      else { els.bo.hidden = true; }
    }
  }

  function open(form) {
    build();
    var size = parseInt(form.getAttribute('data-bundle-size'), 10);
    if (!size || size < 1) return false;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return false;
    if (!CW) return false;
    COLORS = CW.forSize(size);
    modal.querySelector('[data-bqp-rows]').innerHTML = CW.rowsHTML(COLORS, P);
    ctx = {
      size: size,
      variantId: idInput.value,
      title: form.getAttribute('data-bundle-title') || 'Bundle',
      price: form.getAttribute('data-bundle-price') || '',
      soldOut: []
    };
    applySoldOut();
    state = CW.defaultMix(COLORS, size, null);   // originals first, in-stock colours preferred
    els.title.textContent = ctx.title;
    els.size.textContent = size;
    render();
    modal.hidden = false;
    document.documentElement.classList.add('bqp-open');
    hideFloatingWidgets();          // tuck the chat bubble (or any bottom-right FAB) out of the way
    requestAnimationFrame(function () { modal.classList.add('is-in'); });
    return true;
  }

  // Mark sold-out colour rows disabled with a "Sold out" badge (per open, off ctx.soldOut).
  function applySoldOut() {
    for (var i = 0; i < COLORS.length; i++) {
      var c = COLORS[i];
      var row = modal.querySelector('[data-bqp-row="' + c.key + '"]');
      if (!row) continue;
      var sold = isSold(c.key);
      row.classList.toggle('is-soldout', sold);
      var badge = row.querySelector('.bqp__soldout');
      if (sold && !badge) {
        badge = document.createElement('span');
        badge.className = 'bqp__soldout';
        badge.textContent = T.soldOut || 'Sold out';
        var st = row.querySelector('.bqp__stepper');
        if (st) row.insertBefore(badge, st);
      }
      if (badge) badge.style.display = sold ? '' : 'none';
    }
  }

  function close() {
    if (!modal) return;
    restoreFloatingWidgets();
    modal.classList.remove('is-in');
    document.documentElement.classList.remove('bqp-open');
    setTimeout(function () { if (modal) modal.hidden = true; }, 280);
  }

  /* Hide the chat launcher (Shopify Inbox) — and any other small bottom-right
     fixed widget — while the picker is open, so it never covers Add to Cart.
     The chat lives in an app-injected iframe with an unstable selector, so we
     detect it by position rather than hard-coding a class. Reversible. */
  var hiddenWidgets = [];
  function hideFloatingWidgets() {
    hiddenWidgets = [];
    var vw = window.innerWidth, vh = window.innerHeight;
    var nodes = document.body.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el === modal || (modal && modal.contains(el))) continue;
      var cs;
      try { cs = window.getComputedStyle(el); } catch (e) { continue; }
      if (cs.position !== 'fixed' || cs.visibility === 'hidden' || cs.display === 'none') continue;
      var r = el.getBoundingClientRect();
      if (r.width === 0 || r.height === 0) continue;
      // small widget anchored to the bottom-right corner (chat FAB, back-to-top…)
      if (r.bottom > vh - 200 && r.right > vw - 200 && r.width < 260 && r.height < 260) {
        hiddenWidgets.push([el, el.style.visibility]);
        el.style.visibility = 'hidden';
      }
    }
  }
  function restoreFloatingWidgets() {
    for (var i = 0; i < hiddenWidgets.length; i++) {
      hiddenWidgets[i][0].style.visibility = hiddenWidgets[i][1] || '';
    }
    hiddenWidgets = [];
  }

  /* ---- cart drawer wiring (mirrors bold-quick-add.js) ---- */
  function renderDrawer(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var nd = doc.querySelector('cart-drawer');
        var ni = nd ? nd.querySelector('#CartDrawer') : doc.querySelector('#CartDrawer');
        var oi = drawer.querySelector('#CartDrawer');
        if (ni && oi) oi.replaceWith(ni);
        drawer.classList.remove('is-empty');
      }
    }
    if (sections['cart-icon-bubble']) {
      var be = document.querySelector('#cart-icon-bubble');
      if (be) {
        var d2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var inner = d2.querySelector('div.shopify-section');
        be.innerHTML = inner ? inner.innerHTML : sections['cart-icon-bubble'];
      }
    }
  }

  function updateBubble(count) {
    var bubbles = document.querySelectorAll('.cart-count-bubble');
    for (var i = 0; i < bubbles.length; i++) {
      var s = bubbles[i].querySelector('span[aria-hidden="true"]') || bubbles[i];
      s.textContent = count;
    }
    var links = document.querySelectorAll('.bm-hdr__act[href="/cart"]');
    for (var j = 0; j < links.length; j++) { links[j].textContent = 'Bag (' + count + ')'; }
  }

  function addToCart() {
    if (!ctx || total() !== ctx.size) return;
    els.add.disabled = true;
    els.addLabel.textContent = 'Adding…';
    var fd = new FormData();
    fd.append('items[0][id]', ctx.variantId);
    fd.append('items[0][quantity]', 1);
    fd.append('items[0][properties][Colors]', colorsString());
    var boKeysAdd = CW.backorderKeys(COLORS, state);
    if (boKeysAdd.length) fd.append('items[0][properties][Pre-order]', CW.property(boKeysAdd));
    fd.append('sections', 'cart-drawer,cart-icon-bubble');

    fetch('/cart/add.js', {
      method: 'POST', body: fd,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (res) {
        renderDrawer(res.sections);
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); });
      })
      .then(function (cart) {
        updateBubble(cart.item_count);
        try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
        close();
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else if (drawer) drawer.classList.add('active');
        else window.location.href = '/cart';
      })
      .catch(function () {
        els.add.disabled = false;
        els.addLabel.textContent = 'Retry';
      });
  }

  window.BM_BUNDLE_QUICKPICK = {
    shouldIntercept: function (form) {
      if (!form) return false;
      var s = parseInt(form.getAttribute('data-bundle-size'), 10);
      return !!s && s > 0;
    },
    open: function (form) { return open(form); }
  };
})();
